import { createApp, createSSRApp } from "vue";

import App from "./App.vue";
import "./styles.css";

const appRoot = document.querySelector("#app");
const app = appRoot?.hasChildNodes() ? createSSRApp(App) : createApp(App);
app.mount("#app");
